import i18n from 'i18next';
import { isDevelop4Stand } from './stand-presentation';

export function getCurrentLocale(): string {
  if (isDevelop4Stand()) return 'ru';
  if (typeof window !== "undefined") {
    const lng = localStorage.getItem("i18nextLng");
    if (lng) {
      return lng;
    }
  }
  return i18n.resolvedLanguage || i18n.language || "en";
}

export function formatLocale(locale?: string | null): string {
  if (!locale) return 'en-US';

  const norm = locale.trim().replace('_', '-');

  const parts = norm.split('-').filter(Boolean);
  const lang = (parts[0] || 'en').toLowerCase();

  let region = parts[1] ? parts[1].toUpperCase() : undefined;

  if (!region) {
    if (lang === 'en') region = 'US';
    else if (lang === 'ru') region = 'RU';
    else {
      region = lang.toUpperCase();
    }
  }

  return `${lang}-${region}`;
}


export function getAcceptLanguage(): string {
  const lng = getCurrentLocale();
  return formatLocale(lng);
}
